export class ProjectGroupConstants {
  public static readonly GROUP_TYPE_REGISTRY_GROUP = "Registry Group";

  public static readonly GROUP_TYPE_LANDHOLDING = "Landholding";
}

export enum ProjectGroupPermission {
  FULL = "Full",
  PARTIAL = "Partial",
  NONE = "None",
}
